module.exports = __webpack_public_path__ + "static/media/img.large.advtg3.e805c1d1.png";